mutation RestoreSalesDocument($input: SalesDocumentRestoreInput!) {
    salesDocumentRestore(input: $input) {
        salesDocument {
            id
            modalUrl
        }
    }
}
